module.exports = __webpack_public_path__ + "img/bg-lindsey-wallace.dcd4d0eb.jpg";